var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div flex=\"flex\" layout=\"column\"><div flex=\"flex\" layout=\"row\"><div flex=\"33\" class=\"form-group\"><label for=\"title\" class=\"control-label\">Staff Member Name</label><input ng-model=\"vm.docSvc.doc.memberName\" class=\"form-control\"/></div><div flex=\"66\" class=\"form-group\"><label for=\"description\" class=\"control-label\">Job Title</label><input ng-model=\"vm.docSvc.doc.jobTitle\" class=\"form-control\"/></div><div flex=\"33\" class=\"form-group\"><label for=\"price\" class=\"control-label\">Price </label><input ng-model=\"vm.docSvc.doc.price\" class=\"form-control\"/></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/staffMembers/tabs/top-panel.jade
// module id = 294
// module chunks = 0